import { lightFormat } from "date-fns"
import { format } from "date-fns-tz"

export class ReminderDateTimeService {
    static getDate (datetime) {
            return lightFormat(new Date(datetime), 'yyyy-MM-dd')
    }

    static getTime (datetime) {
        return format(new Date(datetime), "HH:mm")
    }

    static setDatetime (date, time) {
        const localDate = `${date} ${time}`
        const utcDate = new Date(localDate).toUTCString()
        return utcDate
    }
}
